import type { UrlEntry, UrlRegion } from '@/types';

export const urls: Record<'career', Record<UrlRegion, UrlEntry>> = {
  career: {
    de: 'karriere-services',
    'de-en': 'career',
    es: 'apoyo-profesional',
    'es-en': 'career',
    fr: 'soutien-professionnel',
    'fr-en': 'career',
    gb: 'career',
    nl: 'carriere-coaching',
    'nl-en': 'career',
    pt: 'servicos-de-carreira',
    'pt-en': 'career',
    us: 'career-services',
    ww: 'career',
  },
};
